/* Version: 3.5.155 */
'use client';
import _extends from '@babel/runtime/helpers/extends';
import { PROGRESS_BAR_VARIANT } from './constants.js';
import ProgressBar from './ProgressBar.js';

var index = _extends(ProgressBar, {
  VARIANT: PROGRESS_BAR_VARIANT
});

export { PROGRESS_BAR_VARIANT, index as default };
